import { Component, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserSessionService } from '../../app-user-session.service';
import { PrintComponent } from '../../blocks/print-component/print-component';
import { OutPatReservationService } from '../out-pat-appointment/out-pat-reservation/out-pat-reservation.service';

@Component({
  selector: 'app-future-reservation-print',
  templateUrl: './future-reservation-print.component.html',
  styleUrls: ['./future-reservation-print.component.css']
})

export class FutureReservationPrintComponent implements OnInit {
  private ngUnsubscribe = new Subject<void>();
  patData: any = <any>{};
  futurePatDataReservationList: any = [];
  autoPrint = false;
  dynamicComponent: any;
  @ViewChild('printComponent') printComponent: PrintComponent;

  constructor(

    private _userSessionService: UserSessionService,
    private _outPatReservation: OutPatReservationService,
    public translate: TranslateService
  ) { }

  ngOnInit() {

    this._userSessionService.subscribeToKey$('FutureReservationPrint')
      .subscribe(key => {
        if (key.value) {
          this.patData = key.value;
          this.patData.patCode=this.patData.patientCode
          this.getPatientFutureReservationByPatCode(this.patData)
        }

      })
  }

  getPatientFutureReservationByPatCode(patient: any) {
    this._outPatReservation.getPatientFutureReservationByPatCode(patient)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          if (res && res.data && res.data.length > 0) {
            this.futurePatDataReservationList=res.data
          }
        },
        error => console.log(error),
        () => {
          this.autoPrint = true;
          setTimeout(() => {
            if (this.printComponent) {
              this.printComponent.PrintView()
            }
          }, 200);
        });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }


}
